/* STATUS / AGENT NOTES (2026-10-01): Agent START: Codex verified JSON cart mutations and quantity-preserving replacement. */
(function (root) {
  'use strict';
  function createClient(fetcher, base) {
    base = base || '/';
    var REVIEW = 'The change could not be verified. Please review your cart before checking out.';
    var uncertain = Object.create(null);
    function request(path, body) {
      return fetcher(base + path, body ? {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      } : { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (response) {
        return response.json().catch(function () { return null; }).then(function (data) {
          if (!response.ok || !data || data.status >= 400) throw new Error((data && data.description) || 'The cart response could not be verified.');
          if (!Array.isArray(data.items)) throw new Error('The cart response could not be verified.');
          return data;
        });
      }, function () { throw new Error('Please check your connection and try again.'); });
    }
    function propertiesKey(properties) {
      return JSON.stringify(Object.keys(properties || {}).sort().filter(function (key) {
        return properties[key] !== '' && properties[key] != null;
      }).map(function (key) { return [key, properties[key]]; }));
    }
    function identity(item, id, properties) {
      return String(item.variant_id || item.id) === String(id) &&
        propertiesKey(item.properties) === propertiesKey(properties) && !item.selling_plan_allocation;
    }
    function unique(cart, id, properties) {
      var matches = cart.items.filter(function (item) { return identity(item, id, properties); });
      if (matches.length > 1) throw new Error('Your cart changed. Please review it and try again.');
      return matches[0];
    }
    function upgrade(variantId, removeKey, expectedQuantity) {
      if (uncertain[removeKey]) return Promise.reject(new Error(REVIEW));
      var old, baseline = 0, attempted = false, finished = false;
      return request('cart.js').then(function (cart) {
        old = cart.items.find(function (item) { return item.key === removeKey; });
        if (!old || old.selling_plan_allocation || String(old.variant_id) === String(variantId) || Number(expectedQuantity) !== old.quantity) {
          throw new Error('Your cart changed. Please review it and try again.');
        }
        var target = unique(cart, variantId, old.properties);
        baseline = target ? target.quantity : 0;
        attempted = true;
        return request('cart/add.js', { items: [{ id: Number(variantId), quantity: old.quantity, properties: old.properties || {} }] });
      }).then(function () {
        return request('cart.js');
      }).then(function (cart) {
        var current = unique(cart, old.variant_id, old.properties);
        var target = unique(cart, variantId, old.properties);
        if (!current || current.quantity !== old.quantity || !target || target.quantity !== baseline + old.quantity) {
          throw new Error('Your cart changed. Please review it and try again.');
        }
        return request('cart/change.js', { id: current.key, quantity: 0 });
      }).then(function (cart) {
        var target = unique(cart, variantId, old.properties);
        if (unique(cart, old.variant_id, old.properties) || !target || target.quantity !== baseline + old.quantity) {
          throw new Error('Please review your cart before checking out.');
        }
        finished = true;
        return cart;
      }).catch(function (error) {
        if (!old || finished || !attempted) throw error;
        // Re-read after a failed/ambiguous response before undoing any addition.
        return request('cart.js').then(function (cart) {
          var current = unique(cart, old.variant_id, old.properties);
          var target = unique(cart, variantId, old.properties);
          var extra = (target ? target.quantity : 0) - baseline;
          var intact = current && current.quantity === old.quantity;
          if (!current && extra === old.quantity) return cart;
          if (intact && extra === 0) throw error;
          if (intact && extra > 0 && extra <= old.quantity) {
            return request('cart/change.js', { id: target.key, quantity: baseline }).then(function (after) {
              var remaining = unique(after, variantId, old.properties);
              if ((remaining ? remaining.quantity : 0) !== baseline) throw new Error(REVIEW);
              throw error;
            });
          }
          throw new Error(REVIEW);
        }).catch(function (reconcileError) {
          if (reconcileError === error) throw error;
          uncertain[removeKey] = true;
          throw new Error(REVIEW);
        });
      });
    }
    function add(id) {
      var key = 'add:' + id, baseline, attempted = false, accepted;
      if (uncertain[key]) return Promise.reject(new Error(REVIEW));
      return request('cart.js').then(function (cart) {
        var current = unique(cart, id, {});
        baseline = current ? current.quantity : 0;
        attempted = true;
        return request('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
      }).then(function (data) {
        accepted = data;
        return request('cart.js');
      }).catch(function (error) {
        if (!attempted) throw error;
        return request('cart.js').then(function (cart) {
          var current = unique(cart, id, {});
          var quantity = current ? current.quantity : 0;
          if (quantity === baseline + 1) return cart;
          if (quantity === baseline) throw error;
          throw new Error(REVIEW);
        }).catch(function (reconcileError) {
          if (reconcileError === error) throw error;
          if (accepted) return accepted;
          uncertain[key] = true;
          throw new Error(REVIEW);
        });
      });
    }
    return { upgrade: upgrade, add: add };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = createClient;
  if (root && root.fetch) root.ScoochCartTransactions = createClient(root.fetch.bind(root), root.Shopify && root.Shopify.routes ? root.Shopify.routes.root : '/');
})(typeof window === 'undefined' ? null : window);
/* Agent END: Codex verified JSON cart mutations and quantity-preserving replacement. */
